import { render } from "./DotsLoader.vue?vue&type=template&id=1b3bf714"
import script from "./DotsLoader.vue?vue&type=script&lang=js"
export * from "./DotsLoader.vue?vue&type=script&lang=js"

import "./DotsLoader.vue?vue&type=style&index=0&id=1b3bf714&lang=css"

import exportComponent from "/srv/swensa.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__